<!-- TODO: (CXSPA-7603) - Remove feature flag next major release. -->
<button
  *cxFeature="'a11yLinkBtnsToTertiaryBtns'"
  #expandButton
  class="btn btn-tertiary"
  (click)="triggerZoom()"
>
  {{ 'productImageZoomTrigger.expand' | cxTranslate }}
  <cx-icon [type]="iconType.EXPAND_ARROWS"></cx-icon>
</button>

<button
  *cxFeature="'!a11yLinkBtnsToTertiaryBtns'"
  #expandButton
  class="btn btn-link cx-action-link"
  (click)="triggerZoom()"
>
  <span>
    {{ 'productImageZoomTrigger.expand' | cxTranslate }}
    <cx-icon [type]="iconType.EXPAND_ARROWS"></cx-icon
  ></span>
</button>
